var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMarkerOtherPoiMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.7651978,39.2623901l-1.1339111,1.7000122C31.1419067,41.5714722,32,42.3602905,32,43c0,1.2236328-3.1162109,3-8,3 s-8-1.7763672-8-3c0-0.6396484,0.8580322-1.4284058,2.3684082-2.0374756l-1.1337891-1.7000732 C15.2298584,40.1641235,14,41.4802856,14,43c0,2.8505859,4.2988281,5,10,5s10-2.1494141,10-5 C34,41.4802246,32.7700195,40.1640625,30.7651978,39.2623901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0048828,22c3.3085938,0,6-2.6914062,6-6s-2.6914062-6-6-6s-6,2.6914062-6,6S20.6962891,22,24.0048828,22z  M24.0048828,12c2.2060547,0,4,1.7939453,4,4s-1.7939453,4-4,4s-4-1.7939453-4-4S21.7988281,12,24.0048828,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1308594,42.9990234C22.5478516,43.6259766,23.2460938,44,24,44c0.6057739,0,1.1682739-0.2507324,1.5852661-0.6708984 C25.6865845,43.2268066,25.7867432,43.1224976,25.8681641,43l7.8193245-11.7236328C37.2148438,26.0175781,40,21.8662109,40,16 c0-8.8222656-7.1777344-16-16-16S8,7.1777344,8,16c0,5.8691406,2.7851562,10.0195312,6.3105469,15.2734375L22.1308594,42.9990234z  M24,2c7.7197266,0,14,6.2802734,14,14c0,5.2578125-2.5048828,8.9921875-5.9716797,14.1601562L24.203125,41.8916016 c-0.0898438,0.1367188-0.3154297,0.1376953-0.4072266-0.0009766l-7.8242188-11.7304688C12.5048828,24.9921875,10,21.2578125,10,16 C10,8.2802734,16.2802734,2,24,2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerOtherPoiMedium);
export default __webpack_public_path__ + "static/media/location-marker-other-POI--medium.1b94dc6312f9d35d85600a10a5669216.svg";
export { ForwardRef as ReactComponent };